module.exports = __webpack_public_path__ + "img/electricCar-green.f3e9074a.svg";